import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const Grow = () => {
  return (
    <div className="wrap main_wrap">
      <Header />
      <div className="grow_wrap">
        <div className="page_banner_box">
          <div
            className="page_banner animate__animated animate__fadeIn"
            style={{ animationDuration: "2s" }}
          ></div>
          <div className="banner_text_box">
            <div className="banner_title">성장클리닉</div>
          </div>
        </div>
        <div className="grow_content_area">
          <div className="grow_top_box">
            <div className="grow_content left">
              <div className="grow_img_box">
                <div className="grow_img"></div>
              </div>
              <div className="grow_text_box">
                <div className="grow_text">닫힌 성장판</div>
              </div>
            </div>
            <div className="grow_content right">
              <div className="grow_img_box">
                <div className="grow_img"></div>
              </div>
              <div className="grow_text_box">
                <div className="grow_text">열린 성장판</div>
              </div>
            </div>
          </div>
          <div className="grow_middle_box">
            <div className="grow_text_box">
              <div className="grow_title">*키성장검사내용 및 비용</div>
              <div className="grow_text">
                1. 성장판 검사(골연령 검사) 8만원
                <br /> 골연령의 확인을 위한 기본적 검사입니다.
              </div>
              <div className="grow_text">
                2.성장종합혈액검사 : 19-25만원
                <br /> 성장에 관련된 여러 인자 및 영양 상태를 포함한 다양한
                검사를 포함하고 있으며 사춘기 및 아동의 특징에 따라 검사항목이
                달라 비용이 상이할 수 있습니다.
              </div>
            </div>
          </div>
          <div className="grow_bottom_box">
            <div className="grow_img_box">
              <div className="grow_bottom_img"></div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Grow;
